module.exports = __webpack_public_path__ + "static/img/avatar_default.1fbfaa95.png";